import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Modal, ModalBody, ModalFooter, ModalHeader, Form, Label, Input, FormFeedback } from 'reactstrap'
import { createSelector } from 'reselect';
import { toggleAdformCredentialModal } from '../../../../slices/modals/reducer';
import { useFormik } from 'formik';
import * as Yup from "yup";
import classnames from 'classnames'
import { saveAdformCredential } from '../../../../slices/publish/adform/thunk';
import ErrorAlert from '../../../../Components/Common/ErrorAlert';
import { resetAdformCredentialError } from '../../../../slices/publish/reducer';

function AdformCredentialModal() {
  const dispatch = useDispatch();

  const selectStates = createSelector(state => state, state => ({
    modalState: state.Modal.adformCredentialModal,
    adformCredentialError: state.Publish.adformCredentialError,
    adformCredentialErrorMsg: state.Publish.adformCredentialErrorMsg
  }));
  const { modalState, adformCredentialError, adformCredentialErrorMsg } = useSelector(selectStates);

  function closeModal() {
    dispatch(toggleAdformCredentialModal());
    setTimeout(() => {
      validation.handleReset();
    }, 300);
  }

  const validation = useFormik({
    enableReinitialize: true,
    initialValues: {
      adformClientId: '',
      adformClientSecret: '',
    },
    validationSchema: Yup.object().shape({
      adformClientId: Yup.string().required("Please enter Adform client id"),
      adformClientSecret: Yup.string().required("Please enter Adform client secret"),
    }),
    onSubmit: async (values, { resetForm }) => {
      const isSaved = await dispatch(saveAdformCredential(values));
      if (isSaved) {
        closeModal();
      }
    }
  });

  return (
    <Modal isOpen={modalState} toggle={closeModal} centered size='md'>
      <ModalHeader className='p-3' toggle={closeModal}>
        Save Credential
      </ModalHeader>
      <Form onSubmit={e => {
        e.preventDefault();
        validation.handleSubmit();
        return false;
      }}>
        <ModalBody>
          {adformCredentialError ?
            <div className='w-100'>
              <ErrorAlert errorState={adformCredentialError} errorMessage={adformCredentialErrorMsg} resetError={resetAdformCredentialError} />
            </div>
            : null}
          <div className='w-100 d-flex justify-content-between'>
            <Label htmlFor='adformClientId'>Adform Client Id</Label>
            {validation.touched.adformClientId && !validation.errors.adformClientId ? (
              <FormFeedback valid>Looks good</FormFeedback>
            ) : null}
            {validation.touched.adformClientId && validation.errors.adformClientId ? (
              <FormFeedback type="invalid">{validation.errors.adformClientId}</FormFeedback>
            ) : null}
          </div>
          <Input
            type='text'
            id='adformClientId'
            name='adformClientId'
            className={'form-control ' + classnames({ 'is-valid': validation.touched.adformClientId && !validation.errors.adformClientId })}
            onChange={validation.handleChange}
            onBlur={validation.handleBlur}
            invalid={validation.touched.adformClientId && validation.errors.adformClientId ? true : false}
            value={validation.values.adformClientId} />
          <div className='w-100 d-flex justify-content-between mt-2'>
            <Label htmlFor='adformClientSecret'>Adform Client Secret</Label>
            {validation.touched.adformClientSecret && !validation.errors.adformClientSecret ? (
              <FormFeedback valid>Looks good</FormFeedback>
            ) : null}
            {validation.touched.adformClientSecret && validation.errors.adformClientSecret ? (
              <FormFeedback type="invalid">{validation.errors.adformClientSecret}</FormFeedback>
            ) : null}
          </div>
          <Input
            type='password'
            id='adformClientSecret'
            name='adformClientSecret'
            className={'form-control ' + classnames({ 'is-valid': validation.touched.adformClientSecret && !validation.errors.adformClientSecret })}
            onChange={validation.handleChange}
            onBlur={validation.handleBlur}
            invalid={validation.touched.adformClientSecret && validation.errors.adformClientSecret ? true : false}
            value={validation.values.adformClientSecret} />
        </ModalBody>
        <ModalFooter>
          <button className='btn btn-light' onClick={closeModal}>Close</button>
          <button type='submit' className='btn btn-success'>Save Credential</button>
        </ModalFooter>
      </Form>

    </Modal>
  )
}

export default AdformCredentialModal
